import React from 'react';
import { HeroIconTrendingDown, HeroIconTrendingUp } from 'toolbox';

const StatsBarItem = ({ label, value, delta = null }) => {
  return (
    <div className="flex flex-col overflow-x-hidden">
      <div className="text-sm font-semibold tracking-wide uppercase text-jcap-300">
        {label}
      </div>
      <div className="flex items-center">
        <div className="text-3xl text-gray-200">{value}</div>
        {delta !== null && (
          <div className="ml-5 text-base text-right">
            <div className="text-base font-semibold leading-tight uppercase">
              {delta == 0 ? (
                'No Change'
              ) : delta > 0 ? (
                <>
                  <HeroIconTrendingUp className="inline h-4" />
                  {delta
                    .toFixed(4)
                    .replace(/(\.[1-9]+)([0]+)$/, '$1')
                    .replace('0.0000', '')}
                  %
                </>
              ) : (
                <>
                  <HeroIconTrendingDown className="inline h-4" />
                  {delta
                    .toFixed(4)
                    .replace(/(\.[1-9]+)([0]+)$/, '$1')
                    .replace('0.0000', '')}
                  %
                </>
              )}
            </div>
            <div className="text-xs leading-tight tracking-tight opacity-50 text-jcap-300">
              Since previous
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsBarItem;
